// extracted by mini-css-extract-plugin
export default {"root":"styles_root__uvccJ","timeBlock":"styles_timeBlock__tNSl4"};